<template>
  <section class="custom-width d-flex flex-column px-3">
    <table :id="`${tableName}`" style="table-layout: auto">
      <thead>
        <tr>
          <th class="border px-4 py-3 d-flex align-items-center">
            <span
              class="text-center text-capitalize font-weight-bolder font-size-h5"
              style="flex-basis: 80%"
            >
              {{ tableName }}</span
            >
          </th>
        </tr>
        <tr>
          <th class="border px-4 py-2">
            <input
              :id="`search-${tableName}`"
              type="search"
              class="border custom-input rounded w-100 py-2 px-3 text-dark-75"
              @keyup="filterInputs"
              :placeholder="`Search ${tableName}`"
            />
          </th>
        </tr>
      </thead>
      <tbody :class="`${tableName}-tb`">
        <template v-if="items.length === 0">
          <tr>
            <!--            <td class="border px-4 py-2">{{ label }}</td>-->
            <td class="border px-4 py-2">Select item</td>
          </tr>
        </template>
        <template v-else>
          <div class="list-container">
            <tr
              v-for="(item, index) in items"
              :key="index"
              class="d-block w-100"
            >
              <td
                class="border px-4 py-2 d-flex justify-space-between align-center"
              >
                <div class="d-flex align-center">
                  <div
                    class="form-check form-check-sm form-check-custom form-check-solid me-2 min-w-20px min-h-20px"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="item.is_selected"
                      @click="
                        (event) =>
                          toggleSelect(event.target.checked, item, index)
                      "
                    />
                  </div>
                  <span class="font-size-lg py-1 font-weight-medium ms-2">
                    {{ item.title }}
                  </span>
                </div>
                <!--                <div class="d-flex align-center justify-end">-->
                <!--                  <button-->
                <!--                    :disabled="item?.is_selected === false"-->
                <!--                    @click="(event) => handleNextPress(event, item.index)"-->
                <!--                    class="btn btn-sm btn-icon btn-circle btn-bg-light btn-hover-light-info"-->
                <!--                    :class="`${tableName}-tb-${item.index}-next-btn`"-->
                <!--                  >-->
                <!--                    <span class="svg-icon">-->
                <!--                      <v-icon size="19"> mdi-arrow-right </v-icon>-->
                <!--                    </span>-->
                <!--                  </button>-->
                <!--                </div>-->
              </td>
            </tr>
          </div>
        </template>
      </tbody>
    </table>
  </section>
</template>

<script>
import { ADD_REMOVE_PAGES_TO_SELECTED_SUB_PLAN } from "@/core/services/store/subscriptionPlans.module";

export default {
  name: "NestedDataTable",
  props: {
    tableName: {
      type: String,
      required: true,
    },
    // handleLocationSelect: {
    //   type: Function,
    //   required: false,
    // },
  },
  computed: {
    // planDetails: function() {
    //   return this.$store.getters.getWESSORTPLANSelectedPlanDetails;
    // },
    items: function () {
      return this.$store.getters.getSUBSCRIPTIONPLANSAllPages;
    },
  },
  methods: {
    // toggleSelectAll(isChecked) {
    //   if (this.tableName === "chutes") {
    //     this.$store.commit(SELECT_ALL_CHUTES, isChecked);
    //
    //     this.$store.getters.getWESSORTPLANLocations.forEach((location) => {
    //       location.is_selected = false;
    //     });
    //
    //   } else if (this.tableName === "locations") {
    //     this.$store.commit(SELECT_ALL_LOCATIONS, isChecked);
    //
    // },
    toggleSelect(isChecked, selectedField, index) {
      this.$store.commit(ADD_REMOVE_PAGES_TO_SELECTED_SUB_PLAN, {
        index,
        selectedField,
        forAdding: isChecked,
      });
    },
    // handleNextPress(event, itemId) {
    //   this.handleLocationSelect(itemId, event);
    // },
    filterInputs() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("search-" + this.tableName);
      filter = input.value.toUpperCase();
      table = document.getElementById(this.tableName);
      tr = table.getElementsByTagName("tr");

      // Loop through all table rows, and hide those who don't match the search query
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) === -1) {
            tr[i].classList.replace("d-block", "d-none");
          } else {
            tr[i].classList.replace("d-none", "d-block");
          }
        }
      }
    },
  },
};
</script>

<style scoped>
td:hover {
  background: #fafafa;
}

.custom-input {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
  outline: none;
  font-weight: normal;
}

.custom-input:focus {
  box-shadow: 0 0 0 3px rgb(66 153 225 / 50%);
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.custom-width {
  width: 100%;
}

.list-container {
  overflow-y: scroll;
  max-height: 36vh !important;
}

.list-container::-webkit-scrollbar {
  display: none !important; /* for Chrome, Safari, and Opera */
}

.list-container {
  -ms-overflow-style: none !important; /* IE and Edge */
  scrollbar-width: none !important; /* Firefox */
}

@media (min-width: 1550px) {
  .list-container {
    max-height: 42vh !important;
  }
}

@media (min-width: 1800px) {
  .list-container {
    max-height: 48vh !important;
  }
}

@media (min-width: 2000px) {
  .list-container {
    max-height: 52vh !important;
  }
}

@media (min-width: 2200px) {
  .list-container {
    max-height: 56vh !important;
  }
}
</style>
